// extracted by mini-css-extract-plugin
export default {"root":"Arrows_root__eowdF","row":"Arrows_row__-AspA","movein":"Arrows_movein__6YaNB"};